module.exports = __webpack_public_path__ + "static/media/notion_ai.029f8f49.png";